export const EllipseIcon = () => {
  const rx = 30; // horizontal radius
  const ry = 20; // vertical radius

  return (
    <svg width="45" height="45" viewBox="-25 -35 50 70">
      <ellipse
        cx="0"
        cy="0"
        rx={rx}
        ry={ry}
        fill="#fff"
        stroke="#333"
        strokeWidth="1"
      />
    </svg>
  );
};